<template>
  <div class="container">
    <div class="chat">
      <div class="intro">
        <img src="../assets/logo.svg" alt="" />
        <h3>Hi,{{ setTime() }}</h3>
        <p>
          我是睿智科技招贤纳士小助手，有什么可以帮助你的吗？如果还没想好，也可以试着问以下问题哦～
        </p>
      </div>
      <div class="more-function">
        <div
          v-for="item in functionList"
          :key="item.type"
          class="func flex-column-center"
          @click="getNav(item.type)"
        >
          <img :src="item.imgSrc" alt="" />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="msg-wrap">
        <div
          v-for="(item, index) in msgList"
          :key="index"
          :class="['msg', item.isMine ? 'self' : 'other']"
        >
          <div v-if="item.isMine">
            <p>{{ item.msg }}</p>
          </div>
          <div v-else>
            <div v-for="(child, childIndex) in item.child" :key="childIndex">
              <p v-if="child.type === 'text'">{{ child.msg }}</p>
              <p v-else-if="(child.type = 'link')">
                ★<a
                  @click="getDetail(child)"
                  :href="child.innerLink ? 'javascript:;' : child.linkUrl"
                  >{{ child.msg }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <div ref="endPage"></div>
    </div>
    <div class="bottom">
      <input type="text" v-model="val" class="inp" />
      <div class="send" @click="sendMsg">发送</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      val: "",
      nowTime: "",
      responseMsg: {},
      msgNav: {
        社招职位: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "了解详细招聘JD，请访问：",
              innerLink: true,
            },
            {
              type: "link",
              msg: "https://wisecotech.zhiye.com",
              innerLink: false,
              linkUrl: "https://wisecotech.zhiye.com",
            },
          ],
        },
        校招职位: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "了解详细招聘JD，请访问：",
              innerLink: true,
            },
            {
              type: "link",
              msg: "https://wisecotech.zhiye.com",
              innerLink: false,
              linkUrl: "https://wisecotech.zhiye.com",
            },
          ],
        },
        实习生招聘: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "了解详细招聘JD，请访问：",
              innerLink: true,
            },
            {
              type: "link",
              msg: "https://wisecotech.zhiye.com",
              innerLink: false,
              linkUrl: "https://wisecotech.zhiye.com",
            },
          ],
        },
        实习时间要求: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "每周可实习3天及以上，持续实习3个月及以上。",
            },
          ],
        },
        "睿智今年有校园招聘吗？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "有的，详细可以了解下招聘门户网站",
            },
            {
              type: "link",
              msg: "https://wisecotech.zhiye.com",
              innerLink: false,
              linkUrl: "https://wisecotech.zhiye.com",
            },
            {
              type: "text",
              msg: "或是关注公众号信息",
            },
          ],
        },
        "销售岗位需要有行业相关资源或经验吗？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "不一定哦，如果有相关行业经验是加分项。",
            },
          ],
        },
        "Java开发和Java实施的区别是？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "Java开发更侧重代码能力，专注产品的开发和打磨。",
            },
            {
              type: "text",
              msg: "Java实施更贴近业务，会驻场到客户方进行需求对接、定制化开发。",
            },
          ],
        },
        睿智对学历的要求: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "针对不同的岗位需求，会有对应要求，具体请查阅各岗位要求信息哦",
            },
          ],
        },
        "非985，211有机会进睿智科技吗？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "如果非985、211院校背景，只要技术业务能力够硬是有机会加入睿智科技的",
            },
          ],
        },
        如何加入睿智: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "(1) 简历投递-匹配您的岗位进行简历投递，HR会进行认真审阅。",
            },
            {
              type: "text",
              msg: "(2) 面试-经过HR及业务部门认真审核通过的简历人选进入专业和HR面试，我们会认真收集面试官的面试反馈意见以便确定后续步骤。",
            },
            {
              type: "text",
              msg: "(3) 背景调查与核实-对学历及过往工作等信息进行核实确认。",
            },
            {
              type: "text",
              msg: "(4) offer-经过我们的管理层审核后会为应聘成功的候选人发放睿智录用通知。",
            },
            {
              type: "text",
              msg: "(5) 体检-睿智会提供入职体检套餐。",
            },
            {
              type: "text",
              msg: "(6) 入职-入职当天会收获入职大礼包并有导师1V1帮带，协助您尽快融入了解公司及岗位。",
            },
          ],
        },
        面试形式: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "睿智的招聘面试形式分为3种，电话面试、远程视频面试、现场，在不同岗位不同场景下会安排适当的面试形式，我们都会从您的面试官收集面试反馈，然后确定后续流程。",
            },
          ],
        },
        实习有转正机会吗: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "每一位实习生都有转正的机会。",
            },
          ],
        },
        员工福利待遇: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "市场有竞争力的薪酬、全额七险一金、股票期权、各种福利奖金、补助、带薪假期、人才培养；",
            },
            {
              type: "text",
              msg: "市场有竞争力的薪酬、全额七险一金、股票期权、各种福利奖金、补助、带薪假期、人才培养；",
            },
          ],
        },
        "有关人才培养的计划有哪些？": {
          isMine: false,
          child: [
            {
              type: "link",
              msg: "睿智科技多项举措促进人才激励与培养",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/aseCpUV7KM6V_p8eC7QcSg",
            },
            {
              type: "link",
              msg: "出发啦，少年！睿智科技“半年成才计划——摘星之旅”拉开序幕",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/hbDiKaIUDynxehGWcTdYsw",
            },
            {
              type: "link",
              msg: "长相守，到白头——睿智科技青年精英计划之长白山培训",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/k7KEnPEcI3_juNavm-wxIQ",
            },
          ],
        },
        晋升机制: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "睿智每年有2次晋升窗口期",
            },
          ],
        },
        涨薪机制: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "睿智每年有2次调薪窗口期",
            },
          ],
        },
        新员工培训机制: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "睿智为新入职员工提供多种培训和学习机会，并有专属导师1V1帮带，对于应届生会有半年成才培训计划帮助新员工们尽快适应公司文化、环境以及岗位工作。",
            },
          ],
        },
        上下班时间: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "灵活弹性打卡，错开早晚高峰",
            },
          ],
        },
        出差福利: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "可在内部平台中申请交通酒店预定，无需个人垫付，并享受额外出差补贴。",
            },
          ],
        },
        "睿智科技的工作氛围怎样？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "睿智是一个充满活力、创造力和爱的大家庭。",
            },
          ],
        },
        "睿智科技公司会搞活动吗？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "每个季度和节日睿智小姐姐都会给大家安排。",
            },
          ],
        },
        "睿智科技的办公环境怎样？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "5A级办公环境。",
            },
          ],
        },
        "睿智科技周围交通方便吗？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "睿智科技在选择职场上首先考虑的因素就是交通方便，各职场位置均是地铁直达。",
            },
          ],
        },
        "睿智科技有带薪年假吗？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "是有带薪年假的，年假是根据工作年限算的。除了假期的福利外，睿智科技的薪酬福利也较丰厚，基本工资、全额七险一金、各种奖金、过节福利等，优秀员工还有机会获得公司的股票期权。此外，公司还有一些更具人性化的福利，比如配有多功能健身房，每周的羽毛球锻炼日等。总之，在睿智科技，不光有带薪年假，还有带薪病假和司龄假，其他的福利待遇也挺多的。",
            },
          ],
        },
        企业文化: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "愿景、使命、价值观",
            },
          ],
        },
        公司介绍: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "睿智合创（北京）科技有限公司成立于2014年6月，总部位于北京，并在上海、广州、深圳、武汉、济南设有分公司。",
            },
            {
              type: "text",
              msg: "睿智科技是国内一流的金融科技公司，以雄厚的风险管理能力、自研的专利建模技术、强大的数据驱动决策科学能力为行业所知名。",
            },
            {
              type: "text",
              msg: "通过行业普遍应用的大数据评分、分析咨询、风险赋能、软件实施、培训等业务线，睿智科技为包括央行在内的全部中国国有大行和股份制银行、多家民营银行、城商农商行、外资行、几乎全部的消金和大型互联网平台、大多数汽车金融和头部融资租赁、保险等客户提供全生命周期的、行业领先的产品和解决方案；帮助金融客户搭建世界前沿的风险管理能力，助力其实现数字化转型。",
            },
            {
              type: "text",
              msg: "近些年，睿智科技在汽车金融、小微、三农等国家战略发展领域为客户取得了促进降本增效和金融安全的众多实践成果。",
            },
          ],
        },
        睿智在哪些城市设有分公司: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "北京、上海、广州、深圳、武汉、济南",
            },
          ],
        },
        "睿智科技的发展历程是怎样的？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "成立于2014年的睿智科技是一家纯内资的国家高新技术企业，为金融机构提供大数据评分、分析咨询、风险赋能、软件与实施方案等产品和服务。",
            },
            {
              type: "text",
              msg: "看睿智科技的一些介绍和发展大事记，不难发现，这家公司真的挺牛的。",
            },
            {
              type: "text",
              msg: "2017年12月，获评国家高新技术企业。",
            },
            {
              type: "text",
              msg: "2018年7月，完成Pre-A轮1亿元的融资；2019年5月，又获得6.5亿元A轮融资。",
            },
            {
              type: "text",
              msg: "2020年1月，成立北大-睿智智科技Fintech联合实验室；7月，获评中关村高新技术企业；11月又联合全球最大个人信用评分机构FICO合资成立由睿智科技控股的费埃哲睿智信息技术（北京）有限公司。",
            },
            {
              type: "text",
              msg: "2021年1月，董事长陈建获得中关村高端领军人才称号。2022年3月，公司获得北京市“专精特新”小巨人荣誉称号。",
            },
            {
              type: "text",
              msg: "如今，睿智科技的产品及业务被众多国内的大中型银行等金融机构使用，发展前景十分可观。",
            },
          ],
        },
        "可否简单介绍下睿智科技的董事长？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "陈建是广东省高考状元，北京大学国际经济学学士、美国华盛顿大学经济学硕士，CFA，是中国大数据评分领域的领军人物，亦是评分、优化、风险管理领域的技术专家。",
            },
            {
              type: "text",
              msg: "陈建曾作为全球最大个人信用评分机构FICO最年轻的总监被总部派回中国，亲手筹备并创建了FICO中国公司，并担任FICO全球副总裁兼中国区总裁。",
            },
            {
              type: "text",
              msg: "陈建自2018年5月起担任睿智科技董事长，带领公司走上快速发展道路；主导与全球最大个人信用评分机构FICO共同成立“费埃哲睿智”合资公司，全面整合FICO全球化技术创新能力和睿智科技本地化优势；促成建立北大-睿智Fintech联合实验室。",
            },
            {
              type: "text",
              msg: "陈建的著作《现代信用卡管理》和《信用评分模型技术与应用》被中国银行界高度评价，广泛阅读。",
            },
          ],
        },
        "睿智科技有女高管吗？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "有的，睿智科技有很多杰出的女高管，其中女神总裁Sandy总就是极具代表性的一位，请看：",
            },
            {
              type: "link",
              msg: "睿智“她”力量的执着与追求",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/AHn2dlexnyMT1ziavRwaqg",
            },
            {
              type: "link",
              msg: "情暖三月天，美丽三八节—— 睿智科技举办三八节庆祝及生日会活动",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/1YT4ucFW2sWPATMjbSQE2g",
            },
          ],
        },
        "睿智科技的高层和员工都是什么背景啊？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "自公司成立以来，目前形成了300余人的团队。其中超过1/3的成员为国内外硕士及以上学历，毕业于全球各大名校，包括：MIT、哥伦比亚大学、华盛顿大学、南加州大学、悉尼大学、南洋理工大学、香港大学、北京大学、复旦大学、中国人民大学、上海交通大学、中国科技大学、南开大学、武汉大学等；同时公司成员曾在国际知名征信公司、互联网金融和金融标杆型公司如美国运通、摩根大通、花旗银行、Experian、Transunion、FICO、Capital One、PayPal等；以及国内外知名银行、金融公司：招商银行、 渣打银行、平安银行，全球龙头互联网公司如阿里巴巴、携程金融、京东金融、字节跳动等公司担任关键职务，具有深厚的技术积累和行业经验。（15个北大、3个中科大少年班、58个海归、硕士以上占比38%）",
            },
          ],
        },
        "睿智科技的核心竞争力是什么？": {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "金融最本质的内容，归根到底是降低风险和交易成本、提升回报。而金融科技的本质是科技，它是为金融服务的。睿智科技深谙此道，以本土化、国际化、专业性和合规性的完美结合为鲜明特色，在大数据、云计算及人工智能领域打造了一条完整、清晰、坚实的产业链，具备了及其独特的优势与核心竞争力。",
            },
            {
              type: "text",
              msg: "睿智科技高效整合多年来在数据源、算法算力与本土化市场上技术、产品、市场开拓与运营经验等本地化优势，以及全球最大个人信用评分机构FICO全球化技术创新能力，凭借全面与专注、本土与国际、经验与创新的核心竞争力，以及国际一流的技术、服务、运营能力，打造了国内金融风险服务的最佳实践。",
            },
            {
              type: "text",
              msg: "在可以预见的未来，睿智科技将继续致力于打破金融信息非对称，为推动金融事业的发展做出贡献。",
            },
          ],
        },
        了解更多有关睿智大家庭的信息: {
          isMine: false,
          child: [
            {
              type: "link",
              msg: "风有约，花不误——睿智科技Q3生日会来啦！",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/VuueItKDkzXExDmWortUKg",
            },
            {
              type: "link",
              msg: "权威发布！睿智科技荣登“IDC中国Fintech 50”榜单",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/kUfR0TrjcHEjPLfvYDxHxQ",
            },
            {
              type: "link",
              msg: "出发啦，少年！睿智科技“半年成才计划——摘星之旅”拉开序幕",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/hbDiKaIUDynxehGWcTdYsw",
            },
            {
              type: "link",
              msg: "捷报！睿智科技联合华夏银行信用卡中心荣获《亚洲银行家》“中国最佳风险数据与分析技术实施”大奖",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/hN9tVRimb3A0sMeU9zK5KQ",
            },
            {
              type: "link",
              msg: "“2023睿智科技汽车金融峰会”成功举办，40余家机构90余位嘉宾共赴盛会！",
              innerLink: false,
              linkUrl: "https://mp.weixin.qq.com/s/gpjy-bHj8kfCwLiwRRc8Ng",
            },
          ],
        },
        网申: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "网申信息请访问：",
            },
            {
              type: "link",
              msg: "wisecotech.zhiye.com",
              innerLink: false,
              linkUrl: "https://wisecotech.zhiye.com",
            },
          ],
        },
        应聘邮箱: {
          isMine: false,
          child: [
            {
              type: "text",
              msg: "应聘邮箱地址：",
            },
            {
              type: "link",
              msg: "career@wisecotech.com",
              innerLink: false,
              linkUrl: "mailto:career@wisecotech.com",
            },
          ],
        },
      },
      navMsg: [
        {
          mineMsg: "招聘职位",
          response: {
            isMine: false,
            child: [
              {
                type: "link",
                msg: "社招职位",
                innerLink: true,
              },
              {
                type: "link",
                msg: "校招职位",
                innerLink: true,
              },
              {
                type: "link",
                msg: "实习生招聘",
                innerLink: true,
              },
              {
                type: "link",
                msg: "实习时间要求",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智今年有校园招聘吗？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "销售岗位需要有行业相关资源或经验吗？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "Java开发和Java实施的区别是？",
                innerLink: true,
              },
            ],
          },
        },
        {
          mineMsg: "聘用原则",
          response: {
            isMine: false,
            child: [
              {
                type: "link",
                msg: "睿智对学历的要求",
                innerLink: true,
              },
              {
                type: "link",
                msg: "非985，211有机会进睿智科技吗？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "如何加入睿智",
                innerLink: true,
              },
              {
                type: "link",
                msg: "面试形式",
                innerLink: true,
              },
              {
                type: "link",
                msg: "实习有转正机会吗",
                innerLink: true,
              },
            ],
          },
        },
        {
          mineMsg: "应聘渠道",
          response: {
            isMine: false,
            child: [
              {
                type: "link",
                msg: "网申",
                innerLink: true,
              },
              {
                type: "link",
                msg: "应聘邮箱",
                innerLink: true,
              },
            ],
          },
        },
        {
          mineMsg: "员工福利",
          response: {
            isMine: false,
            child: [
              {
                type: "link",
                msg: "员工福利待遇",
                innerLink: true,
              },
              {
                type: "link",
                msg: "有关人才培养的计划有哪些？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "晋升机制",
                innerLink: true,
              },
              {
                type: "link",
                msg: "涨薪机制",
                innerLink: true,
              },
              {
                type: "link",
                msg: "新员工培训机制",
                innerLink: true,
              },
              {
                type: "link",
                msg: "上下班时间",
                innerLink: true,
              },
              {
                type: "link",
                msg: "出差福利",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技的工作氛围怎样？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技公司会搞活动吗？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技的办公环境怎样？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技周围交通方便吗？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技有带薪年假吗？",
                innerLink: true,
              },
            ],
          },
        },
        {
          mineMsg: "关于我们",
          response: {
            isMine: false,
            child: [
              {
                type: "link",
                msg: "企业文化",
                innerLink: true,
              },
              {
                type: "link",
                msg: "公司介绍",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智在哪些城市设有分公司",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技的发展历程是怎样的？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "可否简单介绍下睿智科技的董事长？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技有女高管吗？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技的高层和员工都是什么背景啊？",
                innerLink: true,
              },
              {
                type: "link",
                msg: "睿智科技的核心竞争力是什么？",
                innerLink: true,
              },
            ],
          },
        },
        {
          mineMsg: "更多信息",
          response: {
            isMine: false,
            child: [
              {
                type: "link",
                msg: "了解更多有关睿智大家庭的信息",
                innerLink: true,
              },
            ],
          },
        },
      ],
      msgList: [],
      functionList: [
        {
          name: "招聘职位",
          imgSrc: require("../assets/job@2x.png"),
          type: 0,
        },
        {
          name: "聘用原则",
          imgSrc: require("../assets/field@2x.png"),
          type: 1,
        },
        {
          name: "应聘渠道",
          imgSrc: require("../assets/hire@2x.png"),
          type: 2,
        },
        {
          name: "员工福利",
          imgSrc: require("../assets/employe@2x.png"),
          type: 3,
        },
        {
          name: "关于我们",
          imgSrc: require("../assets/aboutUs@2x.png"),
          type: 4,
        },
        {
          name: "更多信息",
          imgSrc: require("../assets/msg@2x.png"),
          type: 5,
        },
        {
          name: "",
          imgSrc: "",
          type: 6,
        },
        {
          name: "",
          imgSrc: "",
          type: 7,
        },
      ],
    };
  },
  created() {
    this.setTime();
    this.getNav = this.debounce(this.getNav, 600);
    this.getDetail = this.debounce(this.getDetail, 600);
  },
  methods: {
    getDetail(item) {
      if (item.type === "link" && item.innerLink) {
        this.val = item.msg;
        this.sendMsg();
      }
    },
    getNav(index) {
      if (index < 6) {
        let sendMsg = this.navMsg[index];
        this.send({
          isMine: true,
          type: "text",
          msg: sendMsg.mineMsg,
        });
        setTimeout(() => {
          this.send(sendMsg.response);
        }, 500);
      }
    },
    setTime() {
      let date = new Date();
      let h = date.getHours();
      if (h < 6) {
        return "晚上好";
      } else if (h < 12) {
        return "上午好";
      } else if (h < 15) {
        return "中午好";
      } else if (h < 19) {
        return "下午好";
      } else {
        return "晚上好";
      }
    },
    sendMsg() {
      if (!this.val) return;
      this.send({
        isMine: true,
        type: "text",
        msg: this.val,
      });
      setTimeout(() => {
        if (this.msgNav[this.val]) {
          this.send(this.msgNav[this.val]);
        } else {
          this.send({
            isMine: false,
            child: [
              {
                type: "text",
                msg: "hi，我是小睿，有什么可以帮助你的吗？",
              },
              {
                type: "text",
                msg: "如果还没想好，也可以试着问以下问题哦！",
              },
            ],
          });
        }
        this.val = "";
      }, 500);
    },
    // 滚动到底部
    handleScrollBottom() {
      this.$nextTick(() => {
        this.$refs.endPage.scrollIntoView({
          behavior: "smooth",
        });
      });
    },
    send(msg) {
      this.msgList.push(msg);
      this.handleScrollBottom();
    },
    debounce(func, wait, immediate = true) {
      let timeout, args, context, timestamp, result;

      const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp;

        // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) context = args = null;
          }
        }
      };

      return function (...args) {
        context = this;
        timestamp = +new Date();
        const callNow = immediate && !timeout;
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }

        return result;
      };
    },
  },
};
</script>

<style scoped lang="less">
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .chat {
    padding: 0 20px;
    height: calc(100% - 64px); // 底部多给30px间隙
    overflow: scroll;
    .intro {
      margin-top: 30px;
      img {
        width: 140px;
      }
      h3 {
        margin-top: 18px;
        font-size: 16px;
        font-weight: 600;
      }
      p {
        margin-top: 7px;
      }
    }
    .more-function {
      margin-top: 28px;
      padding: 0 0 20px 20px;
      background: #f5f7fc;
      border-radius: 16px 16px 16px 16px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .func {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-right: 20px;
        margin-top: 22px;
        img {
          width: 50px;
        }
        span {
          color: #242730;
          font-size: 12px;
          margin-top: 2px;
        }
        p {
          margin-top: 8px;
        }
      }
    }
    .msg-wrap {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding-bottom: 20px;
      & > div {
        margin-top: 20px;
        padding: 10px;
        max-width: 280px;
      }
      .self {
        align-self: flex-end;
        background-color: #148cfb;
        border-radius: 8px 8px 0 8px;
        p {
          color: #fff;
        }
      }
      .other {
        position: relative;
        background: #f5f7fc;
        border-radius: 8px;
        box-shadow: 0px 0px 0px 0.5px #e2e6f1;
        p {
          color: #242730;
        }
      }
      .other::before {
        content: "";
        position: absolute;
        width: 44px;
        height: 44px;
        left: 0;
        top: -48px;
        background: url(../assets/head.png) center no-repeat;
        background-size: 44px;
        border-radius: 50%;
        box-shadow: 0px 0px 0px 0.5px #e2e6f1;
      }
    }
    p {
      font-size: 12px;
      color: rgba(36, 39, 48, 0.7);
      line-height: 22px;
    }
  }
  .bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 375px;
    height: 54px;
    padding-bottom: 10px;
    box-sizing: border-box;
    padding: 0 20px;
    border-top: 1px solid #f1f2f6;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.1);
    .send {
      width: 61px;
      height: 34px;
      background: #148cfb;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      color: #fff;
      font-size: 13px;
      text-align: center;
      line-height: 34px;
      cursor: pointer;
    }
    .inp {
      width: 256px;
      height: 34px;
      background: #f1f2f6;
      border-radius: 100px 100px 100px 100px;
      opacity: 0.7;
      border: 1px solid #eaeef2;
      box-sizing: border-box;
      padding-left: 20px;
      font-size: 13px;
    }
  }
  h3 {
    font-size: 16px;
    color: #242730;
  }
}
</style>